import {MetricNumericalRenderer} from '../analyticsFormatHelpers';

const wholeNumberFormatter = new Intl.NumberFormat('en');
const fractionalNumberFormatter = new Intl.NumberFormat('en', {maximumFractionDigits: 1});

export const renderNumericalValue: MetricNumericalRenderer = ({value}) => {
  if (value > 100) {
    wholeNumberFormatter.format(Math.round(value));
  }

  return fractionalNumberFormatter.format(value);
};
